import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney } from "helpers";
import { truncate } from "lodash";
import React from "react";

type AddStockToWarehouseProps = {
    resultMessage: {
        message: string;
        components: Record<string, any>[];
        success: boolean;
        summary: {
            stockAdditions: {
                productName: string;
                sku: string;
                inventory: Record<string, any>;
                warehouse: {
                    id: string;
                    name: string;
                };
                previousQuantity: number;
                addedQuantity: number;
                success: boolean;
            }[];
            failed: number;
            successful: number;
            totalRequested: number;
        };
    };
    toolName: string;
};

const AddStockToWarehouse = ({ resultMessage, toolName }: AddStockToWarehouseProps) => {
    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>

                    <SynthTooltip
                        content={
                            "The unique name identifying this specific item in your inventory."
                        }
                        divId={"add-stock-product-column"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    />
                </div>
            ),
            widthClass: "w-[222px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">SKU No. </span>

                    {/* <SynthTooltip
                        content={""}
                        divId={"add-stock-sku"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[110px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Warehouse </span>

                    {/* <SynthTooltip
                        content={""}
                        divId={"add-stock-warehouse"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[166px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Previous stock level
                    </span>

                    {/* <SynthTooltip
                        content={
                            "The actual quantity of the component currently available in stock for sale or use at this moment."
                        }
                        divId={"add-stock-previous-stock-level"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[164px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        New stock level
                    </span>

                    {/* <SynthTooltip
                        content={
                            "The actual quantity of the component currently available in stock for sale or use at this moment."
                        }
                        divId={"add-stock-new-stock-level"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[164px] !border-r-none",
        },

        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Status</span>

                    {/* <SynthTooltip
                        content={
                            ""
                        }
                        divId={"add-stock-status"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[95px] ",
        },
    ];
    const tableBody = resultMessage?.summary?.stockAdditions?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.inventory?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.inventory?.productImageDetails?.productAvatar ||
                                            item?.inventory?.productImageDetails?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.inventory?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="">{item?.inventory?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2 break-all`}
                    >
                        <div>
                            <p className=" ">{item?.inventory?.sku || "N/A"}</p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{truncate(item?.warehouse?.name, { length: 30 })}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">
                            {`${formatMoney()?.format(item?.previousQuantity ?? 0)}${" "}${
                                item?.inventory?.productStockDetails?.unitOfMeasurement || ""
                            }`}
                        </p>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">
                            {`${formatMoney()?.format(
                                item?.addedQuantity + item?.previousQuantity
                            )}${" "}${
                                item?.inventory?.productStockDetails?.unitOfMeasurement || ""
                            }`}
                        </p>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p
                            className={`text-sm px-2 py-[2px] rounded-2xl ${
                                item?.success
                                    ? "text-white bg-[#0AAD0A]"
                                    : "text-red-500 bg-red-100"
                            }`}
                        >
                            {item?.success ? "Added" : "Failed"}
                        </p>
                    </div>
                ),
            },
        ];
    });

    return (
        <div>
            {(toolName === "AddStockToWarehouse" || toolName === "AddStock") &&
                resultMessage?.success &&
                resultMessage?.summary?.stockAdditions?.length > 0 && (
                    <>
                        {resultMessage?.summary?.stockAdditions?.length === 1 && (
                            <div
                                className={`min-w-[316px] !w-fit border border-[#E2E8F0]  rounded-[10px]   space-y-3 shadow-[0px_4px_8px_0px_rgba(16,24,40,0.03)]  `}
                            >
                                <div className="flex items-center gap-2 border-b border-b-slate-100 p-4">
                                    <div className="w-10 h-10 rounded shrink-0 flex items-center justify-center bg-[#DCFCE7] ">
                                        <i className="ri-store-2-line text-xl text-[#16A34A]"></i>
                                    </div>

                                    <div>
                                        <p className="text-sm">
                                            {
                                                resultMessage?.summary?.stockAdditions?.[0]
                                                    ?.inventory?.productName
                                            }
                                        </p>
                                        <p className=" text-slate-500 text-sm">
                                            {
                                                resultMessage?.summary?.stockAdditions?.[0]
                                                    ?.warehouse?.name
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-3 text-xs pt-2 pb-4 px-4 justify-between">
                                    <div className="">
                                        <p className="text-slate-500 space-y-1 ">
                                            Previous Quantity
                                        </p>
                                        <p className="text-slate-950">
                                            {formatMoney()?.format(
                                                resultMessage?.summary?.stockAdditions?.[0]
                                                    ?.previousQuantity ?? 0
                                            )}{" "}
                                            {resultMessage?.summary?.stockAdditions?.[0]?.inventory
                                                ?.productStockDetails?.unitOfMeasurement || ""}
                                        </p>
                                    </div>
                                    <div className="">
                                        <p className="text-slate-500 space-y-1 ">Quantity Added</p>
                                        <p className="text-[#0AAD0A]">
                                            +
                                            {formatMoney()?.format(
                                                resultMessage?.summary?.stockAdditions?.[0]
                                                    ?.addedQuantity ?? 0
                                            )}{" "}
                                            {resultMessage?.summary?.stockAdditions?.[0]?.inventory
                                                ?.productStockDetails?.unitOfMeasurement || ""}
                                        </p>
                                    </div>
                                    <div className="">
                                        <p className="text-slate-500 space-y-1 ">
                                            Updated Stock Level
                                        </p>
                                        <p className="text-slate-950">
                                            {formatMoney()?.format(
                                                resultMessage?.summary?.stockAdditions?.[0]
                                                    ?.addedQuantity +
                                                    resultMessage?.summary?.stockAdditions?.[0]
                                                        ?.previousQuantity
                                            )}{" "}
                                            {resultMessage?.summary?.stockAdditions?.[0]?.inventory
                                                ?.productStockDetails?.unitOfMeasurement || ""}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {resultMessage?.summary?.stockAdditions?.length > 1 && (
                            <CustomTable
                                tableBody={tableBody}
                                tableHeader={tableHeader}
                                isCellBordered={true}
                                stickyHeader={true}
                                headerContainerClass="!bg-slate-50 "
                                headerItemClass="font-rocGroteskMedium "
                                tableClass="mb-4"
                                isScrollable={true}
                                scrollWithin={true}
                                renderEmptyTable={() => null}
                            />
                        )}
                    </>
                )}
        </div>
    );
};

export default AddStockToWarehouse;
